import React from 'react'
import PropTypes from 'prop-types'

import {HeartIcon, HeartSolidIcon} from '../icons'
import {
    Text,
    IconButton,
    useBreakpointValue,
    Spinner
} from '@salesforce/retail-react-app/app/components/shared/ui'
import withRegistration from '../with-registration'
import {useIntl} from 'react-intl'

const IconButtonWithRegistration = withRegistration(IconButton, {isWishlistAction: true})

const ProductLikes = ({
    isFavourite = false,
    wishlistCount,
    isHovered = false,
    onFavouriteToggle,
    productName = 'product',
    isLoadingFreshLikes
}) => {
    const intl = useIntl()
    const isDesktop = useBreakpointValue({base: false, lg: true})

    const handleClick = (e) => {
        e?.preventDefault?.()
        e?.stopPropagation?.()
        if (onFavouriteToggle) {
            onFavouriteToggle(!isFavourite)
        }
    }

    return (
        <>
            {isLoadingFreshLikes ? (
                <Spinner size="xs" display={!isHovered && isDesktop ? 'none' : 'block'} />
            ) : (
                <>
                    <IconButtonWithRegistration
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        data-testid="product-likes-button"
                        width="16px"
                        height="16px"
                        minWidth="16px"
                        variant="unstyled"
                        aria-label={
                            isFavourite
                                ? intl.formatMessage(
                                    {
                                        id: 'product_tile.assistive_msg.remove_from_wishlist',
                                        defaultMessage: 'Remove {product} from wishlist'
                                    },
                                    {product: productName}
                                )
                                : intl.formatMessage(
                                    {
                                        id: 'product_tile.assistive_msg.add_to_wishlist',
                                        defaultMessage: 'Add {product} to wishlist'
                                    },
                                    {product: productName}
                                )
                        }
                        icon={
                            isFavourite ? (
                                <HeartSolidIcon display={!isHovered && isDesktop ? 'none' : 'inline'} width="16px" height="16px" />
                            ) : (
                                <HeartIcon
                                    width="16px"
                                    height="16px"
                                    display={!isHovered && isDesktop ? 'none' : 'inline'}
                                />
                            )
                        }
                        onClick={handleClick}
                    />
                    <Text display={!isHovered && isDesktop ? 'none' : 'block'} fontSize={12}>{wishlistCount || 0}</Text>
                </>
            )}
        </>
    )
}

ProductLikes.propTypes = {
    isFavourite: PropTypes.bool,
    wishlistCount: PropTypes.number,
    isHovered: PropTypes.bool,
    onFavouriteToggle: PropTypes.func,
    productName: PropTypes.string
}

export default ProductLikes
